import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useMemo } from "react";
import { ButtonPanel } from "../../../../../../../base/buttons/button/index.js";
import PanelAccommodation from "../../../../components/panel-accommodation/index.js";
import InputPanel from "../../../../../../others/input-panel/index.js";
import AddRoom from "../../../../components/add-room/index.js";
import PanelErrorMobile from "../../../../components/panel-accommodation/components/panel-error/views/mobile/index.js";
import useAccommodationMobile from "../../../../hooks/useAccommodationMobile.js";
import * as S from "./styled.js";
const MobileAccommodation = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { literals , disableAges =false  } = props;
    const { addRoom ='' , accommodationTitle ='' , accept ='' , accommodationLabel =''  } = literals ?? {};
    const { inputProps , config , people , panelRooms , hasError , error , goToLast , onAddRoom , onAccept , setIsOpen , onChangeRooms  } = useAccommodationMobile(props);
    const renderFooter = useCallback(({ close  })=>/*#__PURE__*/ _jsx(ButtonPanel, {
            onClick: onAccept(close),
            children: accept
        }), [
        accept,
        onAccept
    ]);
    const panel = useMemo(()=>({
            onChange: setIsOpen,
            header: accommodationTitle || accommodationLabel,
            beforeContent: error && /*#__PURE__*/ _jsx(PanelErrorMobile, {
                error: error
            }),
            content: /*#__PURE__*/ _jsx(S.AccommodationPanelWrapper, {
                "data-testid": "AccommodationPanel",
                children: /*#__PURE__*/ _jsxs(S.AccommodationPanelContent, {
                    children: [
                        /*#__PURE__*/ _jsx(PanelAccommodation, {
                            config: config,
                            onChange: onChangeRooms,
                            people: people,
                            rooms: panelRooms,
                            error: error,
                            goToLast: goToLast,
                            disableAges: disableAges
                        }),
                        /*#__PURE__*/ _jsx(S.AccommodationPanelFooter, {
                            children: /*#__PURE__*/ _jsx(AddRoom, {
                                addRoom: addRoom,
                                onAddRoom: onAddRoom,
                                hasError: hasError
                            })
                        })
                    ]
                })
            }),
            footer: renderFooter
        }), [
        accommodationLabel,
        accommodationTitle,
        addRoom,
        config,
        disableAges,
        error,
        goToLast,
        hasError,
        onAddRoom,
        onChangeRooms,
        panelRooms,
        people,
        renderFooter,
        setIsOpen
    ]);
    const modalProps = useMemo(()=>({
            color: 'primary'
        }), []);
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "Accommodation",
        children: /*#__PURE__*/ _jsx(InputPanel, {
            ref: ref,
            inputProps: inputProps,
            panel: panel,
            modalProps: modalProps
        })
    });
});
MobileAccommodation.displayName = 'MobileAccommodation';
export default MobileAccommodation;

//# sourceMappingURL=index.js.map